// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pluralize } from "@conklin/XDL/Utilities";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";

type Props = WidgetProps & HasCategoryContext;

export interface CartTitleStyles {
    container?: InjectableCss;
    titleWrapper?: InjectableCss;
    pageTitle?: TypographyProps;
    itemCountText?: TypographyProps;
}

export const cartTitleStyles: CartTitleStyles = {};

const styles = cartTitleStyles;
export const CartTitle = () => {
    const { itemCount, pageTitle } = useAppSelector(state => {
        return {
            itemCount: getCurrentCartState(state)?.value?.cartLines?.length || 0,
            pageTitle: getCurrentPage(state).fields.title,
        };
    });

    return (
        <StyledWrapper {...styles.container}>
            <Typography {...styles.pageTitle}>{pageTitle}</Typography>

            {itemCount > 0 && (
                <Typography className="product-count-wrapper" {...styles.itemCountText}>
                    {pluralize(itemCount, translate("item"), { showNumber: true })}
                </Typography>
            )}
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: CartTitle,
    definition: {
        group: "Cart",
        allowedContexts: ["CartPage"],
        displayName: "Cart Title And Count",
    },
};
export default widgetModule;
